import { EuiButtonIcon, EuiDatePickerRange, EuiFlexGroup, EuiFlexItem, EuiPanel, EuiText, EuiToken } from '@elastic/eui';
import React,{useEffect, useMemo, useState} from 'react';
import SelectorFecha from '../../../../../shared/components/Combos/Fecha';
import { CreateFechaMoment, ToSQL } from '../../../../../shared/utils/fecha';

export const FechasBloqueParcialScreen = (props) =>{

    const {data, saveData} = props;
    
    const [fechaIni, setFechaIni] = useState(undefined);
    const [fechaFin, setFechaFin] = useState(undefined);

    useEffect(()=>{
        if(data!==undefined){
            let fIni, fFin;
            fIni = data.fechaBloqueoParcialDesde!==null ? CreateFechaMoment(data.fechaBloqueoParcialDesde): undefined;
            fFin = data.fechaBloqueoParcialHasta!==null ? CreateFechaMoment(data.fechaBloqueoParcialHasta): undefined;

            setFechaIni(fIni)
            setFechaFin(fFin)
        }
    },[data])

    const onChangeFechaIni = (value)=>{
        setFechaIni(value)
      }
    
    const onChangeFechaFin = (value)=>{
    setFechaFin(value)
    }

    const onRefresh = ()=> {setFechaIni(undefined); setFechaFin(undefined)}
    const onSave = ()=>{
        const dataSave ={fechaBloqueoParcialDesde:fechaIni!==undefined?ToSQL(fechaIni,'-'):null, fechaBloqueoParcialHasta:fechaFin!==undefined?ToSQL(fechaFin, '-'):null}
        saveData && saveData(dataSave);
    }

    const isInvalidFechaIni = useMemo(()=> fechaIni && fechaIni.isAfter(fechaFin), [fechaIni, fechaFin])
    const isInvalidFechaFin = useMemo(()=> fechaFin && fechaFin.isBefore(fechaIni), [fechaFin, fechaIni])

    const buttons = () =>{
        return (
            <EuiFlexGroup justifyContent='spaceEvenly'>
                <EuiFlexItem grow={false}>
                    <EuiFlexGroup direction='column' justifyContent='center' alignItems='center'>
                        <EuiFlexItem>
                            <EuiButtonIcon className='btnDatePartial btnDatePartialRefresh' iconType='refresh' size='m' onClick={()=> onRefresh()}/>
                        </EuiFlexItem>
                        <EuiFlexItem>
                            <EuiText><p>{`Sin rango de fechas`}</p></EuiText>
                        </EuiFlexItem>
                    </EuiFlexGroup>
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                    <EuiFlexGroup direction='column' justifyContent='center' alignItems='center'>
                        <EuiFlexItem >
                        <EuiButtonIcon className='btnDatePartial btnDatePartialSave' iconType='save' size='m' onClick={()=> onSave()}/>
                        </EuiFlexItem>
                        <EuiFlexItem>
                            <EuiText><p>{`Guardar rango de fechas`}</p></EuiText>
                        </EuiFlexItem>
                    </EuiFlexGroup>
                    
                </EuiFlexItem>
            </EuiFlexGroup>
        )
    }


    const getPanel = useMemo(()=>{
        //const color = (isInvalidFechaIni || isInvalidFechaFin) ? '' : ''
        const textDesde = fechaIni!==undefined ? <strong>{`${fechaIni.format('DD/MM/YYYY')}`}</strong> : <strong>{`(Sin Selección)`}</strong>
        const textHasta = fechaFin!==undefined ? <strong>{`${fechaFin.format('DD/MM/YYYY')}`}</strong> : <strong>{`(Sin Selección)`}</strong>
        const text = (!isInvalidFechaIni && !isInvalidFechaFin) ? <p>{`Se ha seleccionado el rango de fechas `}{textDesde}{` hasta `}{textHasta}</p> : <p><strong>{`Error en el rango de fechas`}</strong></p>
        return(
            <EuiPanel className='panelDatePartial'>
                <EuiFlexGroup direction='column'>
                    <EuiFlexItem>
                        <EuiText textAlign='center'>{text}</EuiText>
                    </EuiFlexItem>
                    <EuiFlexItem grow={false}>
                        {buttons()}
                    </EuiFlexItem>
                </EuiFlexGroup>
            </EuiPanel>
        )
    },[fechaIni,fechaFin])

return (
    <EuiFlexGroup>
        <EuiFlexItem grow={false}>
            <EuiFlexGroup>
                <EuiFlexItem grow={false}>
                    <SelectorFecha
                        selected={fechaIni}
                        onChange={onChangeFechaIni}
                        isInvalid={isInvalidFechaIni}
                        aria-label="Inicio"
                        inline
                        shadow={false}
                    />
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                    <SelectorFecha
                        selected={fechaFin}
                        onChange={onChangeFechaFin}
                        isInvalid={isInvalidFechaFin}
                        aria-label="Fin"
                        inline
                        shadow={false}
                    />
                </EuiFlexItem>
            </EuiFlexGroup>
        </EuiFlexItem>
        <EuiFlexItem>
            {getPanel}
        </EuiFlexItem>
      </EuiFlexGroup>
  )
}